import React from 'react';

function SpecificLocation(props){
  const { area, t } = props;

  let locKey = "default";
  if (area === "Los Angeles" || area === "THE USA") locKey = "Los Angeles";
  else if (area === "Montreal") locKey = "Montreal";
  else if (area === "Vietnam") locKey = "Vietnam";

  return (
    <>
      <p>{t(`processing.locations.${locKey}.p1`)}</p>
      {t(`processing.locations.${locKey}.p2`) !== `processing.locations.${locKey}.p2` && (
        <p>{t(`processing.locations.${locKey}.p2`)}</p>
      )}
    </>
  );
}

const Processing = (props) => {   	
  const { t, loc, changeWord, inputPrRef } = props;
  let cleanTitle = t("processing.label");
  	  
  if(loc){
    return (<div className="content-ac pr hide">
    <input
      className="ac-input top"
      id="ac-10afd"
      name="ac-10afd"
      data-id="2400"
      data-slug="PROCESSING"
      type="checkbox"
      onChange={ () => changeWord('processing clicked') }
      ref={inputPrRef}
    />
    <label className="ac-label" htmlFor="ac-10afd">{ cleanTitle }</label>
    <article className="ac-text ac-10afd"><div className="single-post-interior" tabIndex="0">
      <SpecificLocation
        area 	   = { loc } 
        t={t}
      />
      </div>
      <footer></footer>
	</article>
	</div>);	
    }else{
	    return(<></>)
    }
}

export default Processing;